'use client';
import React from 'react';
import ProgressBar from '@/components/ProgressBar';
import dynamic from 'next/dynamic';

const CommChart = dynamic(() => import('@/app/customer-success/components/CommunicationTrendChart'), { ssr: false });

const channels = [
  { id: 'ch-phone', channel: 'Phone', icon: '📞', conversations: 142, booked: 56, rate: '39%', color: 'secondary' as const },
  { id: 'ch-sms', channel: 'SMS', icon: '💬', conversations: 218, booked: 71, rate: '33%', color: 'success' as const },
  { id: 'ch-email', channel: 'Email', icon: '✉️', conversations: 94, booked: 28, rate: '30%', color: 'warning' as const },
  { id: 'ch-chat', channel: 'Web Chat', icon: '🖥️', conversations: 28, booked: 9, rate: '32%', color: 'secondary' as const },
];

export default function CommunicationHubPanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Communication Hub</h3>
          <p className="text-xs text-muted-foreground mt-0.5">482 conversations today · 164 appointments booked</p>
        </div>
        <div className="bg-success/10 border border-success/20 rounded-md px-3 py-1.5">
          <span className="text-xs font-semibold text-success">34% booking rate</span>
        </div>
      </div>
      <div className="px-5 py-4">
        <CommChart />
        <div className="mt-4 space-y-3">
          {channels.map((ch) => (
            <div key={ch.id}>
              <div className="flex items-center justify-between mb-1.5">
                <div className="flex items-center gap-2">
                  <span className="text-sm">{ch.icon}</span>
                  <span className="text-xs font-medium text-foreground">{ch.channel}</span>
                </div>
                <div className="flex items-center gap-4 text-xs">
                  <span className="text-muted-foreground">{ch.conversations} convos</span>
                  <span className="text-foreground font-medium">{ch.booked} booked</span>
                  <span className="text-success font-semibold font-tabular">{ch.rate}</span>
                </div>
              </div>
              <ProgressBar value={ch.conversations} max={482} color={ch.color} size="md" />
            </div>
          ))}
        </div>
        <div className="mt-4 pt-3 border-t border-border grid grid-cols-3 gap-3 text-xs text-center">
          <div>
            <div className="font-bold text-foreground font-tabular text-base">18</div>
            <div className="text-muted-foreground">Escalated to human</div>
          </div>
          <div>
            <div className="font-bold text-success font-tabular text-base">164</div>
            <div className="text-muted-foreground">Appts booked</div>
          </div>
          <div>
            <div className="font-bold text-foreground font-tabular text-base">2.4 min</div>
            <div className="text-muted-foreground">Avg response time</div>
          </div>
        </div>
      </div>
    </div>
  );
}